import { render, staticRenderFns } from "./DraftList.vue?vue&type=template&id=66bcf710&"
import script from "./DraftList.vue?vue&type=script&lang=js&"
export * from "./DraftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports